/**
 * Payment Configuration
 * Phase 9: Invoice Flow - Payment Links
 *
 * Centralized configuration for payment methods and links
 */

// Payment method configuration
export const PAYMENT_CONFIG = {
    // Stripe Payment Link
    // To create: https://dashboard.stripe.com/payment-links
    stripe: {
        enabled: true,
        // Replace with your actual Stripe Payment Link
        paymentLink: import.meta.env.VITE_STRIPE_PAYMENT_LINK || '',
        displayName: 'Credit Card (Stripe)'
    },

    // Venmo Configuration
    venmo: {
        enabled: true,
        // Your Venmo username
        username: import.meta.env.VITE_VENMO_USERNAME || 'SailorSkills',
        displayName: 'Venmo'
    },

    // Zelle Configuration
    zelle: {
        enabled: true,
        // Email or phone number for Zelle
        email: import.meta.env.VITE_ZELLE_EMAIL || 'payments@sailorskills.com',
        displayName: 'Zelle'
    },

    // Default due date (days)
    defaultDueDays: 30
};

/**
 * Build payment links for an invoice
 * @param {number} amount - Invoice amount
 * @param {string} invoiceNumber - Invoice number
 * @returns {Object} Payment links object
 */
export function buildPaymentLinks(amount, invoiceNumber) {
    const links = {};

    // Stripe Payment Link
    if (PAYMENT_CONFIG.stripe.enabled && PAYMENT_CONFIG.stripe.paymentLink) {
        links.stripe = PAYMENT_CONFIG.stripe.paymentLink;
    }

    // Venmo Deep Link
    if (PAYMENT_CONFIG.venmo.enabled && PAYMENT_CONFIG.venmo.username) {
        // Venmo deep link format
        const note = encodeURIComponent(`Invoice ${invoiceNumber} - Sailor Skills`);
        links.venmo = `venmo://paycharge?txn=pay&recipients=${PAYMENT_CONFIG.venmo.username}&amount=${amount}&note=${note}`;

        // Fallback web link
        links.venmoWeb = `https://venmo.com/${PAYMENT_CONFIG.venmo.username}`;
    }

    // Zelle Email
    if (PAYMENT_CONFIG.zelle.enabled && PAYMENT_CONFIG.zelle.email) {
        links.zelle = PAYMENT_CONFIG.zelle.email;
    }

    return links;
}

/**
 * Get payment method display names
 * @returns {Object} Display names for each payment method
 */
export function getPaymentMethodNames() {
    return {
        stripe: PAYMENT_CONFIG.stripe.displayName,
        venmo: PAYMENT_CONFIG.venmo.displayName,
        zelle: PAYMENT_CONFIG.zelle.displayName
    };
}

console.log('✅ Payment configuration loaded');
